import { defineComponent } from 'vue';
import { COMPONENT_PREFIX, BLOCK_PREFIX } from './constants';

function createComponent(name) {
  var componentName = "".concat(COMPONENT_PREFIX, "-").concat(name);
  var className = "".concat(BLOCK_PREFIX, "-").concat(name);
  return {
    componentName: componentName,
    className: className,
    create: function create(_component) {
      _component.baseName = name;
      _component.name = componentName;
      _component.install = function (vue) {
        vue.component(_component.name, _component);
      };
      return defineComponent(_component);
    },
    createDemo: function createDemo(_component) {
      _component.baseName = name;
      _component.name = 'demo-' + name;
      return defineComponent(_component);
    }
  };
}

export { createComponent };
